export default [
	{
		path: "/client/memberships",
		exact: true,
		component: "Memberships",
		load: true,
	},
];
